import React from "react";
import { SelectFieldFormik } from "ui/componentes/Form/SelectFieldFormik";
import { useSeasonOptions } from "api";

interface SelectSeasonProps {
    autoFocus?: boolean;
}

const SelectSeason: React.FC<SelectSeasonProps> = ({ autoFocus = false }) => {
    const seasonsOptions = useSeasonOptions();
    return (
        <SelectFieldFormik
            id="seasonId"
            name="seasonId"
            label="Temporada"
            options={seasonsOptions}
            autoFocus={autoFocus}
        />
    );
};

export { SelectSeason };
